import { render, staticRenderFns } from "./carousel-detail.vue?vue&type=template&id=4a3cb8d2&"
import script from "./carousel-detail.vue?vue&type=script&lang=ts&"
export * from "./carousel-detail.vue?vue&type=script&lang=ts&"
import style0 from "./carousel-detail.vue?vue&type=style&index=0&module=true&lang=stylus&"
import style1 from "./carousel-detail.vue?vue&type=style&index=1&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports